<div class="admin">
  <evc-platform
    class="admin__platform"
    [inputAppIdentification]="appIdentification()"
    [inputLeftBar]="leftbarConfig()"
    [inputHelpMenu]="helpMenu()"
    [i18nAppService]="i18nService">
    @let organization = currentOrganization();
    <adm-current-org-card
      leftbar-top-content
      [currentOrganization]="organization" />
    <adm-current-org-card
      burger-top-content
      [currentOrganization]="organization" />

    @if (ready()) {
      <main class="admin__container">
        <router-outlet></router-outlet>
      </main>
    }
  </evc-platform>
</div>
